export const FACET_PANEL_WIDTH = 300;
export const FACET_PANEL_MARGIN = 2;
